import SmruLeadForm from "./SmruLeadForm";
import { usePartnerTab } from "./usePartnerTab";

export default function SmruBrochurePage() {
    usePartnerTab("Download Brochure — AI.Prof × SMRU");

    return (
        <SmruLeadForm
            variant="brochure"
            eyebrow="Free Brochure"
            title="Download the AI.Prof × SMRU Brochure"
            subtitle="Tell us where to send it and the brochure will download instantly."
            submitLabel="Get the Brochure"
            brochureUrl="/general/ai.prof_brochure.pdf"
        />
    );
}
